// ======================================================================
// File Name       : ServiceGroupDetailContainer
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import React, { Component } from 'react';
import { Button, Col, Form } from 'react-bootstrap';
import { connect } from 'react-redux';
import * as modalActions from '../../actions/ModalAction';
import * as serviceGroupActions from '../../actions/ServiceGroupAction';
import DialogConfirm from '../../components/DialogConfirm';
import Header from '../../components/Header';
import CustomLink from '../../components/button/CustomLink';
import ModalConductor from '../../components/modal/ModalConductor';
import ServiceGroupDetail from '../../components/serviceGroup/ServiceGroupDetail';
import ServiceGroupServiceRelation from '../../components/serviceGroup/ServiceGroupServiceRelation';
import ServiceGroupSuperUserRelation from '../../components/serviceGroup/ServiceGroupSuperUserRelation';
import { MODE, WRITE } from '../../constants';
import * as MessageTemplate from '../../constants/MessageTemplate';
import * as ModalIds from '../../constants/ModalIds';
import { SERVICE_GROUP_LIST } from '../../constants/PathConstants';
import { canAccessRoute } from '../../utils/AuthedUtils';
import { SERVICE_GROUP_EDIT } from '../../constants/FunctionConstants';
import { hideLoading, showLoading } from '../../utils/PageUtils';
import { SYSTEM_CREATE_FLAG } from '../../constants/CommonConstants';

class ServiceGroupDetailContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      ...props.serviceGroup,
      showModal: false,
    };
    this.onDeleteCancel = this.onDeleteCancel.bind(this);
    this.onDeleteOk = this.onDeleteOk.bind(this);
  }

  componentDidMount() {
    const { match, dispatch } = this.props;
    if (!match || !match.params || match.params.id === null || match.params.id === undefined) {
      this.props.history.goBack();
    } else {
      const { serviceGroup: { serviceGroupList }} = this.props;
      if (!serviceGroupList || Object.keys(serviceGroupList).length === 0) {
        dispatch(serviceGroupActions.getServiceGroupList()).then(() => {
          dispatch(serviceGroupActions.getServiceGroupDetail(match.params.id));
        });
      } else {
        dispatch(serviceGroupActions.getServiceGroupDetail(match.params.id));
      }
    }
  }

  componentWillUnmount() {
    this.props.dispatch(serviceGroupActions.resetInitData());
  }

  shouldComponentUpdate(nextProps, nextState) {
    const shouldNotUpdate =
    nextState.detailServiceGroup === undefined
    && nextState.detailServiceGroupService === undefined
    && nextState.detailServiceGroupSuperUser === undefined
    return !shouldNotUpdate;
  }

  handleEditBtn() {
    const { match, dispatch } = this.props;
    dispatch(serviceGroupActions.getServiceGroupDetail(match.params.id));
    dispatch(modalActions.openModal(ModalIds.SERVICE_GROUP_REGISTER_EDIT));
  }

  openDeleteConfirmDialog(mdContent, mdSize) {
    this.content = mdContent;
    this.mdSize = mdSize;
    this.setState({ showModal: true });
  }

  onDeleteCancel() {
    this.setState({ showModal: false });
  }

  onDeleteOk() {
    const { match, dispatch, history } = this.props;
    this.setState({ showModal: false });
    this.props.dispatch(showLoading());
    dispatch(serviceGroupActions.deleteServiceGroup(match.params.id)).then(() => {
      this.props.dispatch(hideLoading());
      history.push(SERVICE_GROUP_LIST);
    });
  }

  static getDerivedStateFromProps(nextProps, state) {
    const { serviceGroup } = nextProps;
    const { detailServiceGroup, detailServiceGroupService, detailServiceGroupSuperUser, editingServiceGroup } = serviceGroup;
    const newState = { ...state };

    if (detailServiceGroup !== undefined) {
      newState.detailServiceGroup = detailServiceGroup
    }
    if (detailServiceGroupService !== undefined) {
      newState.detailServiceGroupService = detailServiceGroupService;
    }
    if (detailServiceGroupSuperUser !== undefined) {
      newState.detailServiceGroupSuperUser = detailServiceGroupSuperUser;
    }
    // Step 11.0.0 START
    if (editingServiceGroup && !Number.isNaN(editingServiceGroup.systemCreateFlag)) {
      newState.systemCreateFlag = parseInt(editingServiceGroup.systemCreateFlag, 10);
    }

    if (editingServiceGroup) {
      newState.serviceGroupSecernId = editingServiceGroup.serviceGroupSecernId;
    }
    // Step 11.0.0 END
    return {
      ...state,
      ...newState,
    };
  }

  render() {
    const { detailServiceGroup, detailServiceGroupService, detailServiceGroupSuperUser, systemCreateFlag, serviceGroupSecernId } = this.state;
    const { userSecernId, isBelongServiceGroup } = this.props;
    const canEdit = systemCreateFlag === SYSTEM_CREATE_FLAG.USER; // Step 11.0.0
    return (
      <div>
        <CustomLink
          className="margin-right-7 url-list"
          to={SERVICE_GROUP_LIST}
          text="サービスグループ一覧に戻る"
          icon="bi bi-chevron-left"
        />
        <Header name="サービスグループの詳細" />
        <Form className='form-horizontal' style={{ display: 'flow-root' }}>
          <ServiceGroupDetail editingServiceGroup={detailServiceGroup} serviceGroupSecernId={serviceGroupSecernId} />
          <ServiceGroupServiceRelation
            editingServiceGroupService={detailServiceGroupService}
          />
          <ServiceGroupSuperUserRelation
            editingServiceGroupSuperUser={detailServiceGroupSuperUser}
          />
        </Form>
        {!isBelongServiceGroup && canAccessRoute(SERVICE_GROUP_EDIT) ? (
          <Col>
            <Form className='form-horizontal'>
              <Form.Group className="margin-top-20 text-center">
                {/* Step 11.0.0 START */}
                {canEdit && (
                  <>
                    <Button variant="primary" className="btn-96 margin-10"
                      onClick={() => this.handleEditBtn()}
                    >
                      編集
                    </Button>
                    <Button
                      variant="primary"
                      className="margin-10 btn-96"
                      onClick={this.openDeleteConfirmDialog.bind(this, MessageTemplate.MSG_DEL_SERVICE_GROUP, null)}
                    >
                      削除
                    </Button>
                  </>
                )}
              {/* Step 11.0.0 END */}
              </Form.Group>
            </Form>
          </Col>
        ) : null}
        <DialogConfirm
          showModal={this.state.showModal}
          onCancel={this.onDeleteCancel}
          mdSize={this.mdSize}
          content={this.content}
          onOK={this.onDeleteOk}
        />
        <ModalConductor history={this.props.history} />
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  const { serviceGroup, authority, authed } = state;
  const userSecernId = authed.authedUser.userInfo.userSecernId;
  const isBelongServiceGroup = authed.authedUser.isBelongServiceGroup;
  return { serviceGroup, authority: authority.authorityInfo.bySecernId, userSecernId, isBelongServiceGroup };
};
export default connect(mapStateToProps)(ServiceGroupDetailContainer);
